import { createAction } from 'redux-actions';

export const MOVE_PRODUCT = 'MOVE_PRODUCT';

export default createAction(MOVE_PRODUCT);
